import { orchestrator } from 'satcheljs';
import { logCacheUpdateForDiagnostics } from '../actions/publicActions';
import insertCacheUpdateLog from '../mutators/insertCacheUpdateLog';
import ensureLoggerInitialized from '../utils/initializeLogger';
import { now } from 'owa-datetime';
import getStore from '../store/store';
import { maxLogsForDiagnosticsPanel } from '../constants';
import removeCacheUpdateLog from '../mutators/removeCacheUpdateLog';
import { isFeatureEnabled } from 'owa-feature-flags';

orchestrator(logCacheUpdateForDiagnostics, actionMessage => {
    if (!isFeatureEnabled('cal-cacheDiagnostics')) {
        return;
    }

    const { cacheUpdateLogs } = getStore();

    if (cacheUpdateLogs.length == maxLogsForDiagnosticsPanel) {
        // if we already have the maxLogs, then remove the first
        removeCacheUpdateLog();
    }

    ensureLoggerInitialized();
    if (!actionMessage.cacheUpdateLog.timestamp) {
        // If timestamp is not passed, then assume that time of calling the log is the approximate time of request made
        actionMessage.cacheUpdateLog.timestamp = now();
    }
    insertCacheUpdateLog(actionMessage.cacheUpdateLog);
});
